import { Bell, ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useNotifications } from "@/hooks/useNotifications";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "@/contexts/LanguageContext";
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

interface NotificationBellProps {
  collapsed?: boolean;
}

export function NotificationBell({ collapsed = false }: NotificationBellProps) {
  const { unreadCount } = useNotifications();
  const location = useLocation();
  const { t } = useTranslation();

  const isActive = location.pathname === '/notifications';

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        tooltip={t('notifications')}
        isActive={isActive}
      >
        <NavLink to="/notifications" className="flex items-center gap-3">
          <div className="relative">
            <Bell className="h-5 w-5" />
            {unreadCount > 0 && (
              <Badge 
                className="absolute -top-2 -right-2 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs"
                variant="destructive"
              >
                {unreadCount > 9 ? '9+' : unreadCount}
              </Badge>
            )}
          </div>
          {!collapsed && <span>{t('notifications')}</span>}
          {!collapsed && isActive && (
            <ChevronRight className="ml-auto h-4 w-4" />
          )}
        </NavLink>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
